import { FunctionComponent, useEffect, useState } from "react";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { useNavigate } from "react-router-dom";
import TableSearch from "../../Components/Table/components/TableSearch";

interface CourseMasterProps {}

const CourseMaster: FunctionComponent<CourseMasterProps> = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState<any[]>([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<{ id?: string | number; name?: string }>({});

  const fetchCourses = () => {
    let existingCourses = JSON.parse(localStorage.getItem("tutoring_courses") || "[]");

    if (existingCourses.length === 0) {
      existingCourses = [
        {
          id: 1,
          title: "2025 GATE ASET Premium AI Course",
          shortName: "ASET Premium",
          category: "Competitive Exams",
          status: 1,
          lessons: 12,
          students: 1205,
          progress: 0,
          description: "Premium tutoring for Academic Selective Entrance Test."
        },
        {
          id: 2,
          title: "English(booklet)",
          shortName: "English Bk",
          category: "Language & Literature",
          status: 1,
          lessons: 8,
          students: 840,
          progress: 10,
          description: "Comprehensive English booklet walkthroughs."
        },
        {
          id: 3,
          title: "GATE Sample Exam 3 Walkthrough",
          shortName: "GATE Sample 3",
          category: "Competitive Exams",
          status: 1,
          lessons: 5,
          students: 650,
          progress: 5,
          description: "Step-by-step video explanations for GATE Sample 3."
        },
        {
            id: 4,
            title: "GATE Sample Exam 4 Walkthrough",
            shortName: "GATE Sample 4",
            category: "Competitive Exams",
            status: 0,
            lessons: 10,
            students: 1100,
            progress: 100,
            description: "Full walkthrough for GATE Sample Exam 4."
        }
      ];
      localStorage.setItem("tutoring_courses", JSON.stringify(existingCourses));
    }

    setCourses(existingCourses.map((c: any, index: number) => ({ ...c, index: index + 1, status: c.status === 1 ? true : false })));
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleDelete = () => {
    let existingCourses = JSON.parse(localStorage.getItem("tutoring_courses") || "[]");
    existingCourses = existingCourses.filter((c: any) => c.id !== deleteDialogData.id);
    localStorage.setItem("tutoring_courses", JSON.stringify(existingCourses));
    setDeleteDialogOpen(false);
    fetchCourses();
  };

  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "title",
      renderHeader: () => <b>Course Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "shortName",
      renderHeader: () => <b>Short Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "category",
      renderHeader: () => <b>Category</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,
      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <>
            <IconButtonField
              onClick={() => {
                navigate(`/online-tutoring/courses/create?id=${params.row.id}&students=${params.row.students || 0}&progress=${params.row.progress || 0}`);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.title });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Table rows={courses} columns={columns} exportFileName="Courses">
        <CustomToolbar>
          <h6>Course Master</h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => navigate("/online-tutoring/courses/create")}
            toolTip="Add new course"
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={fetchCourses}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={handleDelete}
      />
    </>
  );
};

export default CourseMaster;
